<template>
  <v-container class="d-flex flex-column flex-nowrap">
    <v-row class="flex-shrink-0 overflow-y-auto">
      <template v-if="$_singleTimelineCefrScoreTimelineDataId !== null">
        <div class="h6">
          {{ timelineDataSet[$_singleTimelineCefrScoreTimelineDataId].name }}
        </div>
        <CefrScoreEditorDetailed
          v-for="(cefrScoreSegmentWithInfo, cefrScoreSegmentId) in $_cefrScoreSegmentsWithInfo[$_singleTimelineCefrScoreTimelineDataId]"
          v-bind:key="cefrScoreSegmentId"
          v-bind:cefr-score-segment="cefrScoreSegmentWithInfo.cefrScoreSegment"
          v-bind:cefr-score-timeline-segment-id="cefrScoreSegmentWithInfo.cefrScoreTimelineSegmentId"
          v-on:update-cefr-score-reason="$_updateCefrScoreReason(cefrScoreSegmentWithInfo.cefrScoreTimelineSegmentId, $event)"
          v-on:update-cefr-score="$_updateCefrScore(cefrScoreSegmentWithInfo.cefrScoreTimelineSegmentId, $event)"
          v-on:update-cefr-score-unratable-reason-id="$_updateCefrScoreUnratableReasonId(cefrScoreSegmentWithInfo.cefrScoreTimelineSegmentId, $event)"
          v-on:update-cefr-score-unratable-reason="$_updateCefrScoreUnratableReason(cefrScoreSegmentWithInfo.cefrScoreTimelineSegmentId, $event)"
        />
      </template>

      <v-expansion-panels
        v-else
        v-model="$data.$_expandedPanelIdx"
      >
        <v-expansion-panel
          v-for="(cefrScoreSegmentsWithInfo, cefrScoreTimelineDataId) in $_cefrScoreSegmentsWithInfo"
          v-bind:key="cefrScoreTimelineDataId"
        >
          <v-expansion-panel-header v-on:click.capture="$_onClickOnExpansionPanelHeader">
            <template v-slot:default="{ open }">
              <div class="cefr-score-header-container">
                <div class="qualitative-feature-name-container text-truncate">
                  {{ timelineDataSet[cefrScoreTimelineDataId].name }}
                </div>
                <v-fade-transition leave-absolute>
                  <div class="cefr-score-sliders-container" v-if="!open">
                    <div
                      class="cefr-score-editor-slider-container"
                      v-for="(cefrScoreSegmentWithInfo, cefrScoreSegmentId) in cefrScoreSegmentsWithInfo"
                      v-bind:key="cefrScoreSegmentId"
                    >
                      <v-icon
                        color="success"
                        v-if="cefrScoreSegmentWithInfo.cefrScoreSegment.data.isScoringDone"
                      >
                        mdi-checkbox-marked-circle

                        <!-- mdi-checkbox-marked-circle-outline -->
                        <!-- mdi-checkbox-marked-circle -->
                      </v-icon>
                      <v-icon
                        color="grey lighten-2"
                        v-else
                      >
                        mdi-checkbox-blank-circle

                        <!-- mdi-checkbox-blank-circle-outline -->
                        <!-- mdi-checkbox-blank-circle -->
                        <!-- mdi-alert-circle -->
                      </v-icon>
                      <CefrScoreEditorSeekToSegmentButton
                        v-if="!cefrScoreSegmentWithInfo.cefrScoreSegment.hasNoRange"
                        v-bind:cefr-score-timeline-segment-id="cefrScoreSegmentWithInfo.cefrScoreTimelineSegmentId"
                      />
                      <CefrScoreEditorSlider
                        v-bind:is-unratable="cefrScoreSegmentWithInfo.cefrScoreSegment.data.isUnratable"
                        v-bind:external-cefr-score="cefrScoreSegmentWithInfo.cefrScoreSegment.data.score"
                        v-bind:cefr-score-timeline-segment-id="cefrScoreSegmentWithInfo.cefrScoreTimelineSegmentId"
                        v-on:update="$_updateCefrScore(cefrScoreSegmentWithInfo.cefrScoreTimelineSegmentId, $event)"
                        v-on:touched="$_onSliderTouched"
                      />
                    </div>
                  </div>
                </v-fade-transition>
              </div>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <CefrScoreEditorDetailed
              v-for="(cefrScoreSegmentWithInfo, cefrScoreSegmentId) in cefrScoreSegmentsWithInfo"
              v-bind:key="cefrScoreSegmentId"
              v-bind:name="cefrScoreSegmentWithInfo.name"
              v-bind:cefr-score-segment="cefrScoreSegmentWithInfo.cefrScoreSegment"
              v-bind:cefr-score-timeline-segment-id="cefrScoreSegmentWithInfo.cefrScoreTimelineSegmentId"
              v-on:update-cefr-score-reason="$_updateCefrScoreReason(cefrScoreSegmentWithInfo.cefrScoreTimelineSegmentId, $event)"
              v-on:update-cefr-score="$_updateCefrScore(cefrScoreSegmentWithInfo.cefrScoreTimelineSegmentId, $event)"
              v-on:update-cefr-score-unratable-reason-id="$_updateCefrScoreUnratableReasonId(cefrScoreSegmentWithInfo.cefrScoreTimelineSegmentId, $event)"
              v-on:update-cefr-score-unratable-reason="$_updateCefrScoreUnratableReason(cefrScoreSegmentWithInfo.cefrScoreTimelineSegmentId, $event)"
              v-on:fold-panel="$_foldPanel"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>

    <v-row id="score-definition" class="flex-shrink-1">
      <v-col></v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
#score-definition {
  max-height: 30%;
}

div.cefr-score-header-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

div.cefr-score-sliders-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

div.cefr-score-editor-slider-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

div.qualitative-feature-name-container {
  width: 30%;
  max-width: 200px;
}
</style>

<script>
import { TimelineSegmentId, providedFunctions, EditorDefinition } from '@Scatt';
import CefrScoreEditorDetailed from './CefrScoreEditor/CefrScoreEditorDetailed.vue'
import CefrScoreEditorSlider from './CefrScoreEditor/CefrScoreEditorSlider.vue'
import CefrScoreEditorSeekToSegmentButton from './CefrScoreEditor/CefrScoreEditorSeekToSegmentButton.vue'
import CefrScoreSegmentData from '../../modules/segmentDataTypes/CefrScoreSegmentData.js'
import CefrScoreChangeHistorySegmentData from '../../modules/segmentDataTypes/CefrScoreChangeHistorySegmentData.js'

class CefrScoreWithInfo {
  static name = 'CefrScoreWithInfo';

  constructor(name, cefrScoreTimelineSegmentId, cefrScoreSegment) {
    this.name = name;
    this.cefrScoreTimelineSegmentId = cefrScoreTimelineSegmentId;
    this.cefrScoreSegment = cefrScoreSegment;
  }
}

const cefrScoreTimelineDataNameRange = 'Range';
const cefrScoreTimelineDataNameAccuracy = 'Accuracy';
const cefrScoreTimelineDataNameFluency = 'Fluency';
const cefrScoreTimelineDataNamePhonology = 'Phonology';
const cefrScoreTimelineDataNameInteraction = 'Interaction';
const cefrScoreTimelineDataNameCoherence = 'Coherence';
const cefrScoreTimelineDataNameOverall = 'Overall CEFR';

export default {
  editorDefinition: new EditorDefinition(
    'CefrScoreEditor',
    'CEFR Score',
  ),

  watch: {
    $_timelineCefrScoreDataSet: {
      handler(newTimelineCefrScoreDataSet) {
        let isCefrScoreTimelineDataFound = {};
        isCefrScoreTimelineDataFound[cefrScoreTimelineDataNameRange] = false;
        isCefrScoreTimelineDataFound[cefrScoreTimelineDataNameAccuracy] = false;
        isCefrScoreTimelineDataFound[cefrScoreTimelineDataNameFluency] = false;
        isCefrScoreTimelineDataFound[cefrScoreTimelineDataNamePhonology] = false;
        isCefrScoreTimelineDataFound[cefrScoreTimelineDataNameInteraction] = false;
        isCefrScoreTimelineDataFound[cefrScoreTimelineDataNameCoherence] = false;
        isCefrScoreTimelineDataFound[cefrScoreTimelineDataNameOverall] = false;

        for (let timelineCefrScoreData of Object.values(newTimelineCefrScoreDataSet)) {
          switch (timelineCefrScoreData.name) {
            case cefrScoreTimelineDataNameRange:
              isCefrScoreTimelineDataFound[cefrScoreTimelineDataNameRange] = true;
              break;
            case cefrScoreTimelineDataNameAccuracy:
              isCefrScoreTimelineDataFound[cefrScoreTimelineDataNameAccuracy] = true;
              break;
            case cefrScoreTimelineDataNameFluency:
              isCefrScoreTimelineDataFound[cefrScoreTimelineDataNameFluency] = true;
              break;
            case cefrScoreTimelineDataNamePhonology:
              isCefrScoreTimelineDataFound[cefrScoreTimelineDataNamePhonology] = true;
              break;
            case cefrScoreTimelineDataNameInteraction:
              isCefrScoreTimelineDataFound[cefrScoreTimelineDataNameInteraction] = true;
              break;
            case cefrScoreTimelineDataNameCoherence:
              isCefrScoreTimelineDataFound[cefrScoreTimelineDataNameCoherence] = true;
              break;
            case cefrScoreTimelineDataNameOverall:
              isCefrScoreTimelineDataFound[cefrScoreTimelineDataNameOverall] = true;
              break;
            default:
              break;
          }
        }
        for (let [ cefrScoreTimelineDataName, isFound ] of Object.entries(isCefrScoreTimelineDataFound)) {
          if (!isFound) {
            let cefrScoreTimelineDataId = this.generateNewHiddenTimelineData(
              CefrScoreSegmentData,
              cefrScoreTimelineDataName,
              false,
            );
            let overallCefrScoreTimelineSegment = CefrScoreSegmentData.generateEmpty(null, null);
            this.setNewSegment(
              cefrScoreTimelineDataId,
              CefrScoreSegmentData,
              overallCefrScoreTimelineSegment,
              cefrScoreTimelineDataName + ' timeline segment is set.',
              'setting ' + cefrScoreTimelineDataName + ' timeline segment',
            );
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },

  components: {
    CefrScoreEditorDetailed,
    CefrScoreEditorSlider,
    CefrScoreEditorSeekToSegmentButton,
  },

  props: {
    annotatorId: { type: String },
    annotatorName: { type: String },
    timelineDataSet: { type: Object },
  },

  data() {
    return {
      $_isSliderTouched: false,
      $_lastExternalCefrScore: null,
      $_expandedPanelIdx: null,
    };
  },

  computed: {
    $_singleTimelineCefrScoreTimelineDataId() {
      let cefrScoreTimelineDataIds = Object.keys(this.$_cefrScoreSegmentsWithInfo);
      if (cefrScoreTimelineDataIds.length !== 1) return null;
      return cefrScoreTimelineDataIds[0];
    },
    $_timelineCefrScoreDataSet() {
      let timelineCefrScoreDataSet = {};
      for (let [ timelineDataId, timelineData ] of Object.entries(this.timelineDataSet)) {
        if (timelineData.segmentDataType === CefrScoreSegmentData) {
          timelineCefrScoreDataSet[timelineDataId] = timelineData;
        }
      }
      return timelineCefrScoreDataSet;
    },
    $_cefrScoreSegmentsWithInfo() {
      let cefrScoreSegmentsWithInfo = {};
      for (let [ cefrScoreTimelineDataId, cefrScoreTimelineData ] of Object.entries(this.$_timelineCefrScoreDataSet)) {
        cefrScoreSegmentsWithInfo[cefrScoreTimelineDataId] = {};
        for (let [ cefrScoreSegmentId, cefrScoreSegment ] of Object.entries(cefrScoreTimelineData.segments)) {
          let cefrScoreTimelineSegmentId = new TimelineSegmentId(cefrScoreTimelineDataId, cefrScoreSegmentId);
            cefrScoreSegmentsWithInfo[cefrScoreTimelineDataId][cefrScoreSegmentId] = new CefrScoreWithInfo(
              cefrScoreTimelineData.name,
              cefrScoreTimelineSegmentId,
              cefrScoreSegment,
            );
        }
      }
      return cefrScoreSegmentsWithInfo;
    },
  },

  inject: providedFunctions,

  methods: {
    /* private */
    $_updateCefrScoreReason(cefrScoreTimelineSegmentId, scoreReason) {
      let cefrScoreSegment = this.timelineDataSet.getSegment(cefrScoreTimelineSegmentId);
      let updatedCefrScoreSegment = cefrScoreSegment.clone();
      updatedCefrScoreSegment.data.scoreReason = scoreReason;
      this.$_updateCefrScoreSegmentData(cefrScoreTimelineSegmentId, updatedCefrScoreSegment);
    },

    $_updateCefrScoreUnratableReasonId(cefrScoreTimelineSegmentId, unratableReasonId) {
      let cefrScoreSegment = this.timelineDataSet.getSegment(cefrScoreTimelineSegmentId);
      let updatedCefrScoreSegment = cefrScoreSegment.clone();
      updatedCefrScoreSegment.data.unratableReasonId = unratableReasonId;
      this.$_updateCefrScoreSegmentData(cefrScoreTimelineSegmentId, updatedCefrScoreSegment);
    },

    $_updateCefrScoreUnratableReason(cefrScoreTimelineSegmentId, unratableReason) {
      let cefrScoreSegment = this.timelineDataSet.getSegment(cefrScoreTimelineSegmentId);
      let updatedCefrScoreSegment = cefrScoreSegment.clone();
      updatedCefrScoreSegment.data.unratableReason = unratableReason;
      this.$_updateCefrScoreSegmentData(cefrScoreTimelineSegmentId, updatedCefrScoreSegment);
    },

    $_updateCefrScore(cefrScoreTimelineSegmentId, externalCefrScore) {
      this.$data.$_lastExternalCefrScore = externalCefrScore;
      let cefrScoreSegment = this.timelineDataSet.getSegment(cefrScoreTimelineSegmentId);
      let updatedCefrScoreSegment = cefrScoreSegment.clone();
      updatedCefrScoreSegment.data.score = externalCefrScore;
      this.$_updateCefrScoreSegmentData(cefrScoreTimelineSegmentId, updatedCefrScoreSegment);
    },

    $_updateCefrScoreSegmentData(cefrScoreTimelineSegmentId, updatedCefrScoreSegment) {
      let cefrScoreChangeHistoryTimelineDataId = this.timelineDataSet
        .ids
        .find(timelineDataId => {
          let timelineData = this.timelineDataSet[timelineDataId];
          if (timelineData.segmentDataType === CefrScoreChangeHistorySegmentData) {
            return timelineData.authorId === this.annotatorId;
          }
        });

      if (cefrScoreChangeHistoryTimelineDataId === undefined) {
        cefrScoreChangeHistoryTimelineDataId = this.generateNewHiddenTimelineData(
          CefrScoreChangeHistorySegmentData,
          'CefrScoreChangeHistory - ' + this.annotatorName,
          true,
        );
      }

      let undoAndRedoCallback = () => {
        let cefrScoreSegment = this.timelineDataSet.getSegment(cefrScoreTimelineSegmentId);
        let newCefrScoreSegment = cefrScoreSegment.clone();
        let newCefrScoreChangeHistoryData = new CefrScoreChangeHistorySegmentData.contentData(cefrScoreTimelineSegmentId, newCefrScoreSegment, new Date());
        let cefrScoreChangeHistorySegment = new CefrScoreChangeHistorySegmentData(null, null, newCefrScoreChangeHistoryData, false);
        this.setNewSegment(
          cefrScoreChangeHistoryTimelineDataId,
          CefrScoreChangeHistorySegmentData,
          cefrScoreChangeHistorySegment,
          'updating CEFR score',
          'CEFR score updated.',
          { ignoresReadonly: true },
        );
      };

      let newCefrScoreChangeHistoryData = new CefrScoreChangeHistorySegmentData.contentData(cefrScoreTimelineSegmentId, updatedCefrScoreSegment, new Date());
      let cefrScoreChangeHistorySegment = new CefrScoreChangeHistorySegmentData(null, null, newCefrScoreChangeHistoryData, false);
      this.setNewSegment(
        cefrScoreChangeHistoryTimelineDataId,
        CefrScoreChangeHistorySegmentData,
        cefrScoreChangeHistorySegment,
        'updating CEFR score change history',
        'CEFR score change history updated.',
        { ignoresReadonly: true },
      );

      this.setSegment(
        cefrScoreTimelineSegmentId,
        CefrScoreSegmentData,
        updatedCefrScoreSegment,
        'updating CEFR score',
        'CEFR score updated.',
        {
          undoCallback: undoAndRedoCallback,
          redoCallback: undoAndRedoCallback,
        },
      );
    },

    $_onSliderTouched() {
      this.$data.$_isSliderTouched = true;
    },

    $_onClickOnExpansionPanelHeader(event) {
      if (this.$data.$_isSliderTouched) event.stopPropagation();
      this.$data.$_isSliderTouched = false;
    },

    $_foldPanel() {
      this.$data.$_expandedPanelIdx = null;
    },
  },
};
</script>
